import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { expValEquals } from '@confluence/feature-experiments';

import { LazySpaceCreatePage } from '../lazyComponents.js';
import { navdexEnd } from '../naxdev.js';

import { LegacyCreateRouteRedirect } from './LegacyCreateRouteRedirect.tsx';

export const CreateBlogRoute: {
	({ params: { spaceKey }, query }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { spaceKey } }: RouteMatch):
		| {
				Screen: {
					showPremiumOnboarding: boolean;
					screenEvent: {
						attributes: {
							navdexPointType: string;
						};
						name: string;
					};
					pageState: {
						spaceKey: string;
					};
				};
				MainLayout: boolean;
		  }
		| false;
} = ({ params: { spaceKey }, query }: RouteMatch): React.JSX.Element =>
	expValEquals('confluence_redirect_legacy_create', 'isEnabled', true) ? (
		<LegacyCreateRouteRedirect contentType="blog" spaceKey={spaceKey} query={query} />
	) : (
		<LazySpaceCreatePage contentType="blogpost" />
	);

CreateBlogRoute.NAVIGATION_PARAMS = ({
	params: { spaceKey },
}: RouteMatch):
	| {
			Screen: {
				showPremiumOnboarding: boolean;
				screenEvent: {
					attributes: {
						navdexPointType: string;
					};
					name: string;
				};
				pageState: {
					spaceKey: string;
				};
			};
			MainLayout: boolean;
	  }
	| false =>
	// The redirect renders no screen of its own, like the other redirect routes.
	expValEquals('confluence_redirect_legacy_create', 'isEnabled', true)
		? false
		: {
				Screen: {
					showPremiumOnboarding: false,
					screenEvent: { name: 'editPageScreen', ...navdexEnd },
					pageState: { spaceKey },
				},
				MainLayout: false,
			};
